import Zone from "@insite/client-framework/Components/Zone";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    isLoading: state.ADIGlobalData.ordersListStore.isLoading,
    userRoles: state.ADIGlobalData.ADIUserRoleStore,
});

const mapDispatchToProps = {
    updateSearchFields,
};

interface OrderHistoryPageStyles {
    loadingOverlay?: LoadingOverlayProps;
};

const styles: OrderHistoryPageStyles = {
    loadingOverlay: {
        css: css`
            & > div:first-child[data-loading="true"] {
                position: fixed;
            }
        `,
    },
};

type Props = HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasShellContext &
    PageProps &
    HasHistory;

const OrderHistoryPage = ({ id, isLoading, userRoles }: Props) => {
    const isOrderHistoryAccess = userRoles.fullAccess || userRoles.limitedAccess || userRoles.employee;
    return (
        <Page>
            <LoadingOverlay {...styles.loadingOverlay} loading={isLoading}>
                {isOrderHistoryAccess ? (
                    <Zone contentId={id} zoneName="Content" />
                ) : (
                    <Zone contentId={id} zoneName="Content1" />
                )}
            </LoadingOverlay>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(withIsInShell(OrderHistoryPage))),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

export const OrderHistoryPageContext = "OrderHistoryPage";
